import { render, staticRenderFns } from "./ConfiguracoesWhiteLabel.vue?vue&type=template&id=eb32743a"
import script from "./ConfiguracoesWhiteLabel.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesWhiteLabel.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesWhiteLabel.vue?vue&type=style&index=0&id=eb32743a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports